export class FacebookPixelHandler {
  constructor() {
    this.initialized = false;
    this._loadPixelScript();
  }

  _loadPixelScript() {
    if (!window.fbq) {
      // Initialize fbq queue
      window.fbq = window.fbq || function() {
        (window.fbq.q = window.fbq.q || []).push(arguments);
      };
      window._fbq = window._fbq || window.fbq;

      // Load the script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      
      script.onload = () => {
        if (process.env.REACT_APP_FACEBOOK_PIXEL_ID) {
          this.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID);
        }
      };

      document.head.appendChild(script);
    }
  }

  _runWhenFbqAvailable(callback, attempt = 1, maxAttempts = 20) {
    if (window.fbq) {
      callback();
    } else if (attempt < maxAttempts) {
      setTimeout(() => this._runWhenFbqAvailable(callback, attempt + 1, maxAttempts), 50);
    }
  }

  init(pixelId) {
    if (!pixelId) return;
    
    this._runWhenFbqAvailable(() => {
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
      this.initialized = true;
    });
  }

  trackPageView() {
    if (!this.initialized) return;
    this._runWhenFbqAvailable(() => {
      window.fbq('track', 'PageView');
    });
  }

  // Track a custom event
  trackEvent(eventName, data) {
    if (!this.initialized) return;
    this._runWhenFbqAvailable(() => {
      window.fbq('track', eventName, data);
    });
  }
} 